import { IconButton, TableRow, TableCell, Collapse, Box, SxProps, Theme } from '@mui/material';
import { Delete, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useCallback, MouseEvent as ReactMouseEvent, useState } from 'react';
import { NumberText } from 'quote-detail/number-text';
import { useQuoteState } from 'shared/contexts';
import { ICustomProduct } from 'shared/types';
import { CustomProductCard } from './custom-product-card';

const containerStyles: SxProps<Theme> = (theme: Theme) => ({
  cursor: 'pointer',
  '& .MuiTableCell-body': {
    '&:first-of-type': {
      paddingLeft: theme.spacing(5),
    },
  },
});
const cardContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  padding: 0,
  backgroundColor: theme.palette.background.paper,
});

interface ICustomProductProps {
  customProduct: ICustomProduct;
  index: number;
  remove: (index?: number | number[] | undefined) => void;
}

export function CustomProductSummary({ customProduct, index, remove }: ICustomProductProps) {
  const { editMode } = useQuoteState();
  const [open, setOpen] = useState(false);

  const removeCustomProduct = useCallback(
    (event: ReactMouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      remove(index);
    },
    [remove, index]
  );

  return (
    <>
      <TableRow sx={containerStyles} onClick={() => setOpen(!open)}>
        <TableCell align='left'>{customProduct.customProductName}</TableCell>
        <TableCell align='left'>{customProduct.customProductQuantity}</TableCell>
        <TableCell align='left'>
          <NumberText prefix='$' fixedDecimalScale decimalScale={2} text={customProduct.customProductPrice} />
        </TableCell>
        <TableCell align='left'>
          <NumberText
            prefix='$'
            decimalScale={2}
            fixedDecimalScale
            text={Number(customProduct.customProductQuantity) * Number(customProduct.customProductPrice)}
          />
        </TableCell>
        <TableCell align='right'>
          <IconButton>{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</IconButton>
          {editMode && (
            <IconButton onClick={removeCustomProduct}>
              <Delete />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={cardContainerStyles} colSpan={8}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box margin={3} pr={35}>
              <CustomProductCard editMode={editMode} index={index} customProduct={customProduct} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
